import Vue from 'vue';
// inline component with template string
export {TLabel, TText, TTextInput, TTextArea, THed, TButton, TSelect, TField};

const TLabel = Vue.component('t-label', {
  props: {
    lvl: {
      type: String,
      default: '1'
    },
    highlight: {
      type: Boolean,
      default: false
    },
    nopad: {
      type: Boolean,
      default: false
    }
  },
  template: `
    <label
          v-bind="$data.attrs"
      :class="{
      'text-md': lvl === '1',
      'text-sm': lvl === '2',
      '': !nopad
      }"
          class="block text-sm">
      <span :class="{'uppercase font-bold text-grey-dark': highlight}">
    <slot></slot>
      </span>
    </label>`
});


const TFormWrapper = Vue.component('t-form-wrapper', {
  template: `
    <div class="">
    <div class="mx-4">
        <slot />
    </div>
    </div>
  `
})

const TPlaceholderBlock = Vue.component('t-placeholder-block', {
  template: `
    <div class="bg-grey-lighter flex items-center justify-center text-grey-darker p-6">
        <slot />
    </div>
  `
})


const TText = Vue.component('t-text', {
  props: {
    lvl: {
      type: String,
      default: '1'
    },
    kind: {
      type: String,
      default: ''
    }
  },
  template: `
    <p
      v-bind="$data.attrs"
      :class="{
      'text-lg': lvl === '1',
      'text-sm': lvl === '2',
      'text-red': kind === 'DANGER',
      'text-yellow-dark': kind === 'WARN',
      'text-grey-darker': kind === 'INFO',
      }"
      class="mb-2">
    <slot></slot>
    </p>`
});


const TButton = Vue.component('t-button', {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    danger: {
      type: Boolean,
      default: false
    },
    inverted: {
      type: Boolean,
      default: false
    }
  },
  template: `
    <button
           class="font-bold text-sm py-2 px-4 focus:outline-none focus:shadow-outline rounded"
      :class="{
      'disabled bg-gray-lighter text-gray': disabled,
      'bg-red hover:bg-white text-white hover:text-red': !disabled && !inverted && danger,
      'text-red border-red border': !disabled && inverted && danger,
      'bg-white hover:bg-white text-full-blue hover:text-full-blue': !disabled && inverted && !danger,
      'bg-full-blue hover:bg-cyan hover:text-full-blue text-white': !disabled && !danger && !inverted
      }"
      :disabled="disabled"
           v-bind="$data.attrs"
           v-on="$listeners"
      >
      <slot></slot>
    </button>
  `
})

const TField = Vue.component('t-field', {
  props: {
    label: {
      type: String,
      default: ''
    },
  },
  template: `<div class="pb-8">
    <t-label v-if="label" highlight class="pb-4">{{label}}</t-label>
    <slot /></div>`
  });

const TSelect = Vue.component('t-select', {
  props: {
    value: {
      type: String,
      default: ''
    },
    opts: {
      type: Array,
      required: true
    },
    size: {
      type: String,
      default: 'lg'
    }
  },
  template: `
    <div class="table border-collapse">
    <div class="table-row">
    <div
        v-for="o in opts" @click="optListener(o.value)"
        class="table-cell border border-collapse text-gray-700 py-2 font-bold cursor-pointer flex-1 text-center"
      :class="{
      ['bg-' + (o.color || 'black') +
      ' border-' + (o.color || 'black') + ' text-white']: o.value === value,
      ['border-' + (o.color || 'black') + ' text-' + o.color]: o.value !== value,
      'text-sm px-4': size === 'sm',
      'text-lg px-6': size === 'lg'
      }">
      {{o.name}}
    </div>
    </div>
    </div>
  `,

  methods: {
    optListener (val) {
      this.$emit('input', val);
    }
  }
})


const TRads = Vue.component('t-rads', {
  props: {
    value: {
      default: ''
    },
    opts: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      sel: this.value
    }
  },

  updated() {
    this.sel = this.value
  },

  template: `
    <div>
    <div
        v-for="o in opts"
        class="mb-4 cursor-pointer flex items-center"
      :class="{

      }">
      <input
            type="radio"
            class="mr-2"
      :id="o.value"
            v-model="sel"
      :value="o.value">
      <t-label lvl="1" class="flex-1" :for="o.value" :key="o.value">{{o.name}}</t-label>
    </div>
    </div>
  `,

  methods: {
    
  },

  watch: {
    sel (to, from) {
      this.$emit('input', to);
    }
  }
})

const TTextInput = Vue.component('t-text-input', {
  props: ['value', 'disabled'],
  template: `
    <input
      @input="$emit('input', $event.target.value)"
      :disabled="disabled"
      :value="value"
      :class="{
        'disabled': disabled
      }"
          class="block appearance-none w-full bg-white border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-grey" />`
    
});

const TTextArea = Vue.component('t-text-area', {
  props: ['value'],
  template: `
    <textarea
             style="resize:none"
             rows="5"
             maxlength="160"
      @input="$emit('input', $event.target.value)"
      :value="value"
             class="block appearance-none w-full bg-white border border-grey-lighter text-black py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-grey">
    </textarea>`
});

const THed = Vue.component('t-hed', {
  props: ['lvl'],
  template: `
    <div :class="{
      'text-2xl pb-4': lvl === '1',
      'text-xl': lvl === '2',
      'text-lg font-bold': lvl === '3',
      'text-md: lvl === '4',
      }">
        <slot></slot>
    </div>`
});
